module.exports = __webpack_public_path__ + "img/evening-usage-icon.a2a7905b.svg";